/* Ayakkabı Prensi — canlı arama debounce
 *
 * SORUN: Tema, arama kutusundaki her tuş vuruşunda /search/suggest'e istek atıyor
 * (theme.js → QuickSearch.handleInput → PredictiveSearch.getSearchResults, debounce yok).
 * "Roux" yazmak 4 istek + Enter ile 5. istek demek. Shopify arama uçlarını kilitleyip
 * "429 local_rate_limited / retry-after: 60" dönüyor; tema düz metin cevabı basamayınca
 * sonuç görünmüyor, 60sn sonra yenileyince geliyor.
 *
 * ÇÖZÜM: input olayını document'te CAPTURE aşamasında yakala (hedefteki dinleyicilerden
 * önce çalışır), temanın anlık fetch'ini durdur, DELAY kadar bekleyip olayı sentetik
 * olarak yeniden gönder. Tema kendi işini normal yapar, sadece bir kez.
 *
 * Tema kodu değiştirilmiyor. Geri almak için: snippets/theme-globals.liquid içindeki
 * tek satırlık <script> dahil etmesini sil.
 */
(function () {
  'use strict';

  var DELAY = 400; // ms — yazma duraklayınca istek atılır
  var MIN_CHARS = 2; // tek harfe istek atma
  var SELECTOR = '.quick-search__input, [data-quick-search] [data-input]';

  var timer = null;

  function resultsBox(input) {
    var root = input.closest('[data-quick-search]');
    return root ? root.querySelector('[data-results]') : null;
  }

  // Temanın kendi dinleyicisini tetikleyecek sentetik olay
  function relay(input) {
    var ev = new Event('input', { bubbles: true });
    ev.apDebounced = true;
    input.dispatchEvent(ev);
  }

  document.addEventListener(
    'input',
    function (e) {
      var input = e.target;
      if (!input || typeof input.matches !== 'function') return;
      if (!input.matches(SELECTOR)) return;
      if (e.apDebounced) return; // kendi ürettiğimiz olay — temaya geçsin

      e.stopImmediatePropagation(); // temanın anlık isteğini durdur
      clearTimeout(timer);

      var value = input.value;

      // Kutu boşaltıldı: temizleme anında olsun, beklemesin
      if (value === '') {
        relay(input);
        return;
      }

      // Tek harf: istek atma, eski sonuçları da bırakma
      if (value.trim().length < MIN_CHARS) {
        var box = resultsBox(input);
        if (box) box.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        relay(input);
      }, DELAY);
    },
    true // capture
  );
})();
